<template>
  <div>
    <div
      v-for="(item, index) in data"
      :key="`exemption-item-${index}`"
      class="mb-3"
    >
      <validation-observer ref="validationRef" novalidate tag="form">
        <callout
          :border-color="getStatusColor(item.statusId)"
          :controlled="true"
          :has-toggle="true"
          :opened="item.isOpen"
          @click:open="onOpenDetails(index)"
        >
          <div class="row">
            <div
              class="col-md-3 mt-2 border-right d-flex flex-column justify-content-center align-items-center"
            >
              <custom-balloon
                :background-color="`bg-${getStatusColor(item.statusId)}`"
                class="w-80 mt-2 mx-md-3 font-weight-bold font-16"
                :text="item.statusName"
              />
              <div class="ml-4 mt-3 text-center">
                <div class="data-name">Fecha de Solicitud:</div>
                <label class="data ml-n3">
                  {{ item.dispenseRequestDate | date }}
                </label>
              </div>
              <div class="ml-4 text-center">
                <div class="data-name">Número de Dispensa:</div>
                <label class="data">
                  {{ item.exemptionDprNumber | empty }}
                </label>
              </div>
            </div>
            <div class="col-md-7 py-3 px-4">
              <div class="row">
                <div class="col-md-4">
                  <div class="data-name">Fecha Desde:</div>
                  <span class="data">{{ item.dispenseStartDate | date }}</span>
                </div>
                <div class="col-md-4">
                  <div class="data-name">Fecha Hasta:</div>
                  <span class="data">{{ item.dispenseEndDate | date }}</span>
                </div>
                <div
                  v-if="item.exemptionType != exemptionTypes.EspecialistaDEPR"
                  class="col-md-4 text-center"
                >
                  <div class="data-name">Supervisados en Corporación:</div>
                  <span class="data">{{ item.dispenseDetailCount }}</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-4">
                  <div class="data-name">
                    {{
                      `Especialista${
                        item.exemptionType == exemptionTypes.EspecialistaDEPR
                          ? ''
                          : ' Supervisor'
                      }:`
                    }}
                  </div>
                  <span class="data">{{ item.specialistName }}</span>
                </div>
                <div class="col-md-4">
                  <div class="data-name">Proveedor:</div>
                  <span class="data">{{ item.companyName }}</span>
                </div>
                <div
                  v-if="item.exemptionType != exemptionTypes.EspecialistaDEPR"
                  class="col-md-4 text-center"
                >
                  <div class="data-name">
                    Supervisados en Otras Corporaciones:
                  </div>
                  <span class="data">
                    {{ item.dispenseDetailOtherCompaniesCount }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-2 text-right pr-5">
              <drop-down
                :data-item="{ item, index }"
                :items="actionItems(item)"
              />
            </div>
          </div>
          <template #edition>
            <custom-tab class="custom-tab-visit-details rounded">
              <custom-tab-item
                :active="item.tabIndex === 0"
                content-class="mt-3 pb-3"
                title="Dispensa"
                @click="item.tabIndex = 0"
              >
                <div
                  v-if="!item.isEditionMode && !showAddEthicDocument"
                  class="bg-gray p-2"
                >
                  <div class="bg-white rounded p-4">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-1" />
                        <span class="color-gray-7 font-weight-bold font-16">
                          Información Adicional Dispensa
                        </span>
                      </div>
                      <div class="col-md-12">
                        <div class="data-name">Comentario de Solicitud:</div>
                        <p class="data">
                          {{ item.exemptionRequestComment }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="isDenyInformationVisible(item.statusId)"
                      class="row mt-3"
                    >
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-1" />
                        <span class="color-gray-7 font-weight-bold font-16">
                          Información de Denegación
                        </span>
                      </div>
                      <div class="col-md-12">
                        <div class="data-name">Razón:</div>
                        <p class="data">
                          {{ item.exemptionDeterminationReasonName }}
                        </p>
                      </div>
                      <div class="col-md-12">
                        <div class="data-name">Comentario:</div>
                        <p class="data">
                          {{ item.denialComment }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.isEditionMode && !showAddEthicDocument"
                  class="bg-gray p-2"
                >
                  <letter-documentation
                    v-if="showLetterDocumentation"
                    @on-cancel="cancelLetterHandler(index)"
                    @on-save="onApproveSave(item, $event)"
                  />
                  <letter-add
                    v-else-if="showLetterAdd"
                    :educative-regions="educativeRegions"
                    :secretary-name-txt="item.secretaryName"
                    @on-cancel="cancelLetterHandler(index)"
                    @on-save="saveLetterHandler(item, $event)"
                  />
                  <div v-else class="bg-white rounded p-4">
                    <div class="row mt-3">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-flag text-orange mr-1 " />
                        <span class="color-gray-7 font-weight-bold font-16">
                          {{ statusTitle }} Dispensa
                        </span>
                      </div>
                      <div
                        v-if="
                          [
                            exemptionStatus.PartiallyApproved,
                            exemptionStatus.Denied,
                          ].includes(statusIdOpennedItem)
                        "
                        class="col-md-12"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-drop-down
                            :id="`reason-${index}`"
                            v-model="selectedItem.reason"
                            custom-error-msg="Favor seleccionar una razón."
                            :error="errors[0]"
                            fieldkey="id"
                            fieldname="name"
                            label="Razón:"
                            :options="reasons"
                            placeholder="Seleccione"
                          />
                        </validation-provider>
                      </div>
                      <div class="col-md-12">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-text-area
                            :id="`comment-${index}`"
                            v-model="selectedItem.comment"
                            custom-error-msg="Favor escribir un comentario."
                            :error="errors[0]"
                            label="Comentario:"
                            :maxlength="3000"
                            name="comment"
                            :rows="3"
                            :show-char-count="true"
                          />
                        </validation-provider>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="d-flex justify-content-end align-items-center"
                        >
                          <action-button
                            id="modal-btn-cancelar"
                            i="fas fa-times-circle"
                            variant="outline-danger mr-2"
                            @click="cancel(index)"
                          >
                            Cancelar
                          </action-button>

                          <action-button
                            i="fa fa-save"
                            variant="success pl-4 pr-4"
                            @click="saveItemDispensa(index, item)"
                          >
                            Guardar
                          </action-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="showAddEthicDocument" class="bg-gray p-2">
                  <add-ethic-letter
                    :exemption-request-id="item.exemptionRequestId"
                    @on-cancel="cancel(index)"
                    @on-refresh="refreshResult()"
                  />
                </div>
              </custom-tab-item>
              <custom-tab-item
                :active="item.tabIndex === 1"
                content-class="mt-3 pb-3"
                title="Historial"
                @click="item.tabIndex = 1"
              >
                <time-line class="m-4">
                  <time-line-item
                    v-for="(historyItem, index) in item.statusHistory.filter(
                      (_, pos) => pos <= item.historySize - 1
                    )"
                    :key="`billing_history_list_${index}`"
                  >
                    <template #date>
                      <ballon
                        :background-color="
                          `text-center font-14 border-none bg-${getStatusColor(
                            historyItem.statusId
                          )}`
                        "
                        class="mt-2 p-0 font-weight-bold font-16"
                        :text="historyItem.statusName"
                      />
                      <div>
                        <p
                          class="color-black font-16 font-weight-bold text-center"
                        >
                          {{
                            $formatDate(
                              historyItem.date,
                              $templateDate.longDateWithHour
                            )
                          }}
                        </p>
                      </div>
                    </template>
                    <div id="main-info" class="row">
                      <div class="col mt-3 mt-md-0 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Usuario:
                        </div>
                        <div class="color-black font-16 font-weight-normal">
                          {{ historyItem.userEmail }}
                        </div>
                      </div>
                      <div class="col mt-3 mt-md-0 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Nombre:
                        </div>
                        <div class="color-black font-16 font-weight-normal">
                          {{ historyItem.userName }}
                        </div>
                      </div>
                    </div>
                    <div v-if="historyItem.reasonComment" class="pt-3">
                      <div class="bg-white p-2 rounded">
                        <div class="row">
                          <div class="col">
                            <em class="fas fa-info-circle color-orange mr-2" />
                            <span class="color-secondary-6 font-14">
                              Razón:
                            </span>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="info-panel-item">
                            <div class="font-weight-normal ml-2 pl-1">
                              {{ historyItem.reasonComment }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </time-line-item>
                </time-line>
                <div class="d-flex justify-content-center mb-3">
                  <action-button
                    v-if="item.statusHistory.length > item.historySize"
                    type="button"
                    variant="outline-success"
                    @click="item.historySize += 5"
                  >
                    Ver más
                  </action-button>
                </div>
              </custom-tab-item>
            </custom-tab>
          </template>
        </callout>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import Callout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import CustomBalloon from 'custom-balloon';
import CustomDropDown from 'custom-drop-down';
import { CustomTab, CustomTabItem } from 'custom-tabs';

import DropDown from 'dropdown';
import Ballon from 'custom-balloon';
import alertMixin from 'utils/mixins/alert.mixin.js';
import LetterAdd from './components/LetterAdd';
import LetterDocumentation from './components/LetterDocumentation';
import AddEthicLetter from './components/AddEthicLetter.vue';
import { TimeLine, TimeLineItem } from '@/components/common/timeline';

import {
  getCodeExemptionDeterminationReason as _getCodeExemptionDeterminationReason,
  changeDispenseStatus as _changeDispenseStatus,
  saveSpecialistLetter as _saveSpecialistLetter,
} from '@/modules/provider/api';

import {
  exemptionStatus,
  getStatusColor,
} from '@/utils/constants/exemptionStatus.js';
import exemptionType from '@/utils/shared/constants/exemptionType';
import exemptionFileType from '@/utils/shared/constants/exemptionFileType';
import _generalApi from '@/modules/app/api';

const DISPENSATION_REQUEST_PAGE = 'dispensation-request-view';

export default {
  name: 'SearchResult',
  components: {
    ValidationObserver,
    ValidationProvider,
    Callout,
    CustomBalloon,
    CustomTextArea,
    CustomDropDown,
    ActionButton,
    DropDown,
    LetterAdd,
    LetterDocumentation,
    AddEthicLetter,
    CustomTab,
    CustomTabItem,
    TimeLine,
    TimeLineItem,
    Ballon,
  },
  mixins: [alertMixin],
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    educativeRegions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    data: [],
    isEditionMode: false,
    statusIdOpennedItem: null,
    selectedItemIndex: null,
    selectedItem: {},
    exemptionStatus,
    reasons: [],
    showLetterAdd: false,
    showLetterDocumentation: false,
    showAddEthicDocument: false,
  }),
  computed: {
    statusTitle() {
      switch (this.statusIdOpennedItem) {
        case exemptionStatus.Approved:
          return 'Aprobar';
        case exemptionStatus.Denied:
          return 'Denegar';
        case exemptionStatus.PartiallyApproved:
          return 'Aprobar Parcial';
        case exemptionStatus.Inactive:
          return 'Inactiva';
        default: {
          return '';
        }
      }
    },
    isStatusIdOpenedApproved() {
      return this.statusIdOpennedItem === exemptionStatus.Approved;
    },
    exemptionTypes() {
      return exemptionType;
    },
    shouldAnnexEthicDetermination() {
      return (item) => {
        return (
          item.exemptionType === this.exemptionTypes.EspecialistaDEPR &&
          (!item.exemptionFiles ||
            !item.exemptionFiles.length ||
            !item.exemptionFiles.some(
              (d) =>
                d.codeDeprExemptionFileId ==
                exemptionFileType.EthicDeterminationLetter
            ))
        );
      };
    },
    isDenyInformationVisible() {
      return (statusId) => {
        return statusId == exemptionStatus.Denied;
      };
    },
    getStatusColor() {
      return (statusId) => {
        return getStatusColor(statusId);
      };
    },
    getStatusMessage() {
      return (statusId) => {
        switch (statusId) {
          case exemptionStatus.Approved:
            return 'Aprobada';
          case exemptionStatus.Denied:
            return 'Denegada';
          case exemptionStatus.PartiallyApproved:
            return 'Aprobada Parcial';
          default:
            return '';
        }
      };
    },
  },
  watch: {
    result: {
      immediate: true,
      handler() {
        this.data = [
          ...this.result.data.map((x) => ({
            ...x,
            tabIndex: 0,
            historySize: 5,
          })),
        ];
      },
    },
  },
  methods: {
    onApproveSave(item, secretaryName) {
      if (secretaryName == '' || secretaryName?.trim()?.length === 0) return;

      this.handleApproved(item, secretaryName);
    },
    onApprove(index, item) {
      if (
        [exemptionType.EspecialistaRempro, exemptionType.Corporación].includes(
          item.exemptionType
        )
      ) {
        this.handleApproved(item);
      } else {
        this.showLetterDocumentation = true;
        this.openStatusChangerForm(index, exemptionStatus.Approved);
      }
    },
    actionItems(item) {
      let actions = [
        {
          name: 'view detail',
          label: 'Ver Detalle',
          icon: 'fas fa-file-search color-primary-1',
          border: 'bottom',
          click: (value) => {
            const item = value.item;
            this.$router.push({
              name: DISPENSATION_REQUEST_PAGE,
              params: {
                dispensationRequestId: item.exemptionRequestId,
              },
            });
          },
        },
        {
          name: 'approve',
          label: 'Aprobar',
          icon: 'fas fa-check-square color-primary-1',
          click: (value) => {
            this.onApprove(value.index, item);
          },
          visible:
            item.statusId !== exemptionStatus.Inactive &&
            item.statusId != exemptionStatus.Amended &&
            this.userHasPermissions('provider.dispenseManagement.approve'),
        },
        {
          name: 'approve partial',
          label: 'Aprobar Parcial',
          icon: 'fas fa-minus-square color-primary-1',
          click: (value) => {
            value.item.tabIndex = 0;
            this.openStatusChangerForm(
              value.index,
              exemptionStatus.PartiallyApproved
            );
            this.callGetDeterminationReasons();
          },
          visible:
            item.statusId !== exemptionStatus.Inactive &&
            item.exemptionType != exemptionType.EspecialistaDEPR &&
            item.exemptionType != exemptionType.EspecialistaRempro &&
            item.statusId != exemptionStatus.Amended &&
            this.userHasPermissions(
              'provider.dispenseManagement.partialapprove'
            ),
        },
        {
          name: 'inactivate',
          label: 'Inactivar',
          icon: 'fas fa-ban color-primary-4',
          click: () => {
            this.inactivateExemption(item);
          },
          visible:
            item.statusId !== exemptionStatus.Inactive &&
            this.userHasPermissions('provider.dispenseManagement.inactive'),
        },
        {
          name: 'denegate',
          label: 'Denegar',
          icon: 'fas fa-times-square color-primary-4',
          click: (value) => {
            value.item.tabIndex = 0;
            this.openStatusChangerForm(value.index, exemptionStatus.Denied);
            this.callGetDeterminationReasons();
          },
          visible:
            item.statusId != exemptionStatus.Amended &&
            item.statusId !== exemptionStatus.Inactive &&
            this.userHasPermissions('provider.dispenseManagement.deny'),
        },
        {
          name: 'historial',
          label: 'Historial',
          icon: 'fas fa-clock color-primary-1',
          click: (value) => {
            value.item.tabIndex = 1;
            this.onOpenDetails(value.index);
          },
        },
        {
          name: 'print specialist letter',
          label: 'Imprimir Carta Especialista',
          icon: 'fas fa-print color-primary-1',
          click: () => this.downloadSpecialistLetterHandler(item),
          visible:
            item.exemptionType == exemptionType.EspecialistaDEPR &&
            item.statusId == exemptionStatus.Approved &&
            item.educativeRegionId != null &&
            this.userHasPermissions(
              'provider.dispenseManagement.downloadspecialistletter'
            ),
        },
        {
          name: 'create letter',
          label: 'Crear carta',
          icon: 'fas fa-plus-circle color-primary-1',
          click: (value) => {
            value.item.tabIndex = 0;
            this.openLetterAdd(value.index);
          },
          visible:
            item.exemptionType == exemptionType.EspecialistaDEPR &&
            item.statusId == exemptionStatus.Approved &&
            item.educativeRegionId == null &&
            this.userHasPermissions(
              'provider.dispenseManagement.createspecialistletter'
            ),
        },
        {
          name: 'add etic determination',
          label: 'Anejar Determinación de Ética',
          icon: 'fas fa-plus color-primary-1',
          click: (value) => {
            value.item.tabIndex = 0;
            this.addEthicDocument(value.index);
          },
          visible: this.shouldAnnexEthicDetermination(item),
        },
        {
          name: 'print letter',
          label: 'Imprimir',
          icon: 'fas fa-print color-primary-1',
          click: () => {
            this.handlerDownloadLetter(item);
          },
          visible:
            item.exemptionType == exemptionType.EspecialistaDEPR &&
            item.statusId == exemptionStatus.Approved &&
            this.userHasPermissions(
              'provider.dispenseManagement.printapprovementletter'
            ),
        },
      ];
      if (item.statusId == exemptionStatus.Approved) {
        actions = actions.filter((f) => f.name != 'approve');
      }
      if (item.statusId == exemptionStatus.PartiallyApproved) {
        actions = actions.filter((f) => f.name != 'approve partial');
      }
      if (item.statusId == exemptionStatus.Denied) {
        actions = actions.filter((f) => f.name != 'denegate');
      }

      return actions;
    },
    async handleApproved(item, secretaryName) {
      this.statusIdOpennedItem = Number(exemptionStatus.Approved);
      await _changeDispenseStatus(item.exemptionRequestId, {
        determinationStatusId: this.statusIdOpennedItem,
        secretaryName: secretaryName,
      });

      this.ShowToast(
        '',
        `La dispensa ha sido ${this.getStatusMessage(
          this.statusIdOpennedItem
        )} exitosamente.`,
        'success'
      );
      this.refreshResult();
    },
    openStatusChangerForm(index, statusCode) {
      this.statusIdOpennedItem = Number(statusCode);
      const currentItem = { ...this.data[index] };

      this.isEditionMode = true;
      this.selectedItemIndex = index;
      this.selectedItem = currentItem;
      this.showLetterAdd = false;
      this.mutateResult(index, true, true);
    },
    closeStatusChangerForm() {
      this.statusIdOpennedItem = null;
      this.isEditionMode = false;
      this.selectedItemIndex = null;
      this.showAddEthicDocument = false;
    },
    onOpenDetails(index) {
      this.mutateResult(index);
    },
    mutateResult(rowIndex, value, isEditionMode) {
      this.data = this.data.map((item, index) => {
        if (index === rowIndex) {
          if (!isEditionMode) {
            item.isOpen = value || !item.isOpen;
            item.isEditionMode = false;
          } else {
            item.isOpen = value || true;
            item.isEditionMode = isEditionMode;
          }
        } else {
          item.isOpen = false;
        }
        return item;
      });
    },
    async inactivateExemption(exemption) {
      const confirmation = await this.ShowCancelModal(
        'Atención',
        'Está seguro que desea inactivar la dispensa?',
        'Sí',
        'No'
      );
      if (confirmation) {
        this.statusIdOpennedItem = Number(exemptionStatus.Inactive);
        await _changeDispenseStatus(exemption.exemptionRequestId, {
          determinationStatusId: this.statusIdOpennedItem,
        });
        this.ShowToast(
          '',
          `La dispensa ha sido inactivada exitosamente.`,
          'success'
        );
        this.refreshResult();
      }
    },
    async callGetDeterminationReasons() {
      const { data: response } = await _getCodeExemptionDeterminationReason();
      this.reasons = response;
    },
    cancel(index) {
      this.mutateResult(index, false, false);
      this.closeStatusChangerForm();
    },
    refreshResult() {
      this.$emit('on-refresh-result');
    },
    async saveItemDispensa(index, { exemptionRequestId }) {
      if (exemptionRequestId) {
        const isValid = await this.$refs.validationRef[index].validate();
        if (!isValid) {
          this.ShowToast('Alerta', 'Información Incompleta', 'error');
          return;
        }

        const { reason, comment } = this.selectedItem;

        await _changeDispenseStatus(exemptionRequestId, {
          determinationStatusId: this.statusIdOpennedItem,
          reasonId: reason?.id,
          comment: comment,
        });

        this.ShowToast(
          '',
          `La dispensa ha sido ${this.getStatusMessage(
            this.statusIdOpennedItem
          )} exitosamente.`,
          'success'
        );
        this.refreshResult();
      }
    },
    openLetterAdd(index) {
      this.openStatusChangerForm(index, exemptionStatus.Approved);
      this.showLetterDocumentation = false;
      this.showLetterAdd = true;
    },
    cancelLetterHandler(index) {
      this.mutateResult(index, false, false);
      this.closeStatusChangerForm();
      this.showLetterAdd = false;
      this.showLetterDocumentation = false;
    },
    saveLetterHandler(item, model) {
      _saveSpecialistLetter(
        item.exemptionRequestId,
        model.educativeRegion.id,
        model.secretaryName
      )
        .then(() => {
          item.educativeRegionId = model.educativeRegion.id;
          this.ShowToast(
            '',
            `La carta ha sido creada exitosamente.`,
            'success'
          );
          this.refreshResult();
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    addEthicDocument(index) {
      this.selectedItemIndex = index;
      this.selectedItem = { ...this.data[index] };
      this.showAddEthicDocument = true;
      this.mutateResult(index, true, false);
    },
    async downloadSpecialistLetterHandler(item) {
      let report = `dispensemanagement/specialistletter/${item.exemptionRequestId}`;
      await _generalApi.downloadReport(report);
    },
    async handlerDownloadLetter(item) {
      const { companyId, specialistId, exemptionRequestId } = item;
      await _generalApi
        .downloadExemptionapprovementlettere({
          companyId,
          specialistId,
          exemptionRequestId,
        })
        .catch(({ response }) => {
          this.ShowToast('Alerta', response.data.message, 'error');
        });
    },
  },
};
</script>
<style scoped>
::v-deep .w-date-fixed {
  width: 170px !important;
}
</style>
